<template>
  <div class="home section-container">

    <!--  -->
    <!-- ORDER DETAIL POPUP  -->
    <!--  -->

    <div id="popupFocusOrder" class="overlay">
     
      <div class="row absolute">
          <button class="btn btn-success btn-filter" v-show="focusOrder.status && focusOrder.status.id == 'NEW'" @click="handleOrderActionPopup(focusOrder, 'PROCESSING')">
            ACCEPTA / PREGATESTE
          </button>
          <button class="btn btn-success btn-filter" v-show="focusOrder.delivery && focusOrder.delivery.id == 'DELIVERY' && focusOrder.status.id == 'PROCESSING'" @click="handleOrderActionPopup(focusOrder, 'PREPARED')">
            PREGATITA
          </button>
          <button class="btn btn-info btn-filter" v-show="focusOrder.status && focusOrder.status.id != 'NEW'" @click="handleOrderActionPopup(focusOrder, 'DELIVERED')">
            LIVREAZA
          </button>
          <button class="btn btn-danger btn-filter" v-show="focusOrder.status && focusOrder.status.id != 'DELIVERED'" @click="handleOrderActionPopup(focusOrder, 'CANCELED')">
            ANULEAZA
          </button>
          <button ref="javascript:void(0)" class="btn btn-default btn-filter btn-close" @click="closeOrderDetails">&times;</button>
      </div>

      <div class="overlay-content" v-if="focusOrder.token">
        <div class="row w-90pr m-t-20px">
          <div class="card w-47-48pr float-left min-height-190">
            <p>#{{focusOrder.token}} <span class="badge-delivery-type">{{focusOrder.delivery.type}}</span></p>
            <p><b>Status:</b> <span class="badge-order-status">{{focusOrder.status.type}}</span></p>
            <p><b>Livrare la:</b> <span class="badge-pickup-datetime">{{focusOrder.pickup_datetime}}</span></p>
            <p><b>Plasata la:</b> {{focusOrder.created_datetime}}</p>
            <p><b>Locatia:</b> {{focusOrder.production_details.location.name}}</p>
            <p>
              <b>Plata:</b> <span v-bind:class="{ 'text-red text-bold' : focusOrder.status && focusOrder.status.id != 'DELIVERED' }">{{focusOrder.payment_type}}</span> <span v-if="focusOrder.payment_type == 'CARD'">💳</span><span v-else="">💰</span>
              <span v-show="focusOrder.payment_type == 'CARD' && focusOrder.capture_transaction_status == 'OK'" class="text-green"> - ACHITATA ✅</span>
              <span v-show="focusOrder.payment_type == 'CARD' && focusOrder.capture_transaction_status == 'NOT OK'" class="text-red text-bold"> - RESPINSA ⚠🔥</span>
              <span v-show="focusOrder.payment_type == 'CARD' && focusOrder.capture_transaction_status != 'OK' && focusOrder.capture_transaction_status != 'NOT OK'" class="text-red text-bold"> - IN CURS DE PLATA ⚡</span>
            </p>
            
          </div>
          <div class="card w-47-48pr float-right min-height-190">
            <p>
              <b>{{focusOrder.delivery_details_firstname || focusOrder.customer.firstname + " " + focusOrder.customer.lastname}}</b> - Nr Comenzi: {{ focusOrder.counter_orders_per_customer}}</p>
              <p>
                <a class="phone-link" v-bind:href="'tel:' + focusOrder.delivery_details_phone">Tel: {{focusOrder.delivery_details_phone}}</a> 
              </p>
            <p><b>Observatii client:</b> <span class="text-red">{{ focusOrder.comment || '(clientul nu a trimis observatii)'}}</span></p>
          </div>
        </div>

        <!--  -->

        <div style="clear: both"></div>

        <div class="row w-90pr m-t-20px" v-show="!!focusOrder.address_billing_id || !!focusOrder.address_shipping_id">
          <div class="card w-47-48pr" v-for="address, type in focusOrder.address" :key="type" style="width: 48%;" :style=" type == 'billing' ? 'float: right;' : 'float: left;'">
            <b>{{type == 'billing' ? 'Adresa facturare:' : 'Adresa livrare:'}}</b>
            <p v-if="address">
              {{address.address_name}} {{address.street}} {{address.apartment}}<br/>
              {{address.city}},
              {{address.state}}<br/>
              {{address.country}}
            </p>
            <p v-else>
              -
            </p>
          </div>
        </div>

        <!--  -->

        <div style="clear: both"></div>

        <div class="row card m-t-20px w-90pr">
          <table class="table orders-table">
            <thead>
                <tr>
                  <th>Denumire</th>
                  <th>Cantitate</th>
                  <th>Pret unitar</th>
                  <th>Total</th>
                </tr>
            </thead>
            <tbody>
              <template v-for="customer in focusOrder.parts">
                <tr v-if="focusOrder.order_type=='GROUP'" class="active"><td colspan="4">Client: {{ customer.customer_name }}</td></tr>
                <tr v-for="prod in customer.items">
                  <td>
                    {{ prod.name }}
                    <div class="product-options" v-for="opt in prod.options">+ {{opt.name}}<span v-if="opt.price>0"> ({{ opt.price }})</span></div>
                    <div class="product-user-details" v-if="prod.additional_info != ''" ><span >Observatii: <i class="text-additional-info">{{prod.additional_info}}</i></span></div>
                  </td>
                  <td>{{ prod.quantity }}</td>
                  <td>{{ prod.price }}</td>
                  <td><b>{{lineTotal(prod.quantity,prod.price_total_product)}}</b></td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <!--  -->

        <div style="clear: both"></div>

        <div class="row w-90pr m-t-20px">
          <div class="row card m-t-20px" style="float: right; width: 48%;">
            <b>TOTALS:</b>
            <ul class="list-totals">
              <li v-for="svalue, slabel in focusOrder.totals">
                <span class="total-type">{{ slabel }}</span>: {{formatValueFloat(svalue)}}
              </li>
            </ul>            
          </div>
        </div>
        
      </div>

    </div>

    <!--  -->
    <!--  PLACEHOLDER WHEN THERE IS NOTHING TO DISPLAY YET -->
    <!--  -->

    <div class="splash" v-if="1 == 0">
      <div class="splash-content">
        <a href="https://taptasty.com" target="_blank">
          <img src="https://www.taptasty.com/images/logo-taptasty.png" >
        </a>
      </div>
    </div>
    
    <!--  -->
    <!-- NEW ORDERS LIST  -->
    <!--  -->
    
    <div class="section-top" v-bind:class="{ 'height-100pr' : ordersNext.length == 0 }" v-if="ordersNew.length || ordersNext.length">
      
      <div class="parent">
        <div class="col-left header-row">COMENZI NOI ({{ ordersNew.length }})</div>
        <!--
        <div class="col-right text-right">
          <button class="btn btn-warning btn-filter">LIVRATE</button>
          <button class="btn btn-warning btn-filter">ANULATE</button>
        </div>
        -->
      </div>

      <div class="section-scroll section-scroll-top"  v-bind:class="{ 'height-92pr' : ordersNext.length == 0 }">
        <div class="parent-list" v-for="order in ordersNew" :key="order.id">
          <div class="col-left-list" @click="openOrderDetails(order)">
            <span class="on badge-order-status">🛒 {{order.status.type}} Order</span>
            <span class="on"><b>Tel: {{order.delivery_details_phone}}</b> <span class="badge-delivery-type">{{order.delivery.type}}</span> ⏰ <span class="text-red text-bold">{{order.pickup_datetime}}</span> </span>
            <span v-show="order.comment && order.comment.length" class="on text-red text-bold">⚡ Clientul are observatii!</span>
            <span class="on">
              Total: {{order.totals_grandtotal}} {{order.currency}} <span v-bind:class="{ 'text-red text-bold' : order.status && order.status.id != 'DELIVERED' }">{{order.payment_type}}</span> <span v-if="order.payment_type == 'CARD'">💳</span><span v-else="">💰</span>
              <span v-show="order.payment_type == 'CARD' && order.capture_transaction_status == 'OK'" class="text-green"> - ACHITATA</span>
              <span v-show="order.payment_type == 'CARD' && order.capture_transaction_status == 'NOT OK'" class="text-red text-bold"> - RESPINSA ⚠🔥</span>
              <span v-show="order.payment_type == 'CARD' && order.capture_transaction_status != 'OK' && order.capture_transaction_status != 'NOT OK'" class="text-red text-bold"> - IN CURS DE PLATA ⚡</span>
            </span> 
          </div>
          <div class="col-right-list text-right">
            <button class="btn btn-success btn-filter" v-show="order.status && order.status.id == 'NEW'" @click="handleOrderActionPopup(order, 'PROCESSING')">ACCEPTA / PREGATESTE</button>
            <button class="btn btn-success btn-filter" v-show="order.delivery && order.delivery.id == 'DELIVERY' && order.status.id == 'PROCESSING'" @click="handleOrderActionPopup(order, 'PREPARED')">PREGATITA</button>
            <button class="btn btn-info btn-filter" v-show="order.status && order.status.id != 'NEW'" @click="handleOrderActionPopup(order, 'DELIVERED')">LIVREAZA</button>
            <button class="btn btn-danger btn-filter" v-show="order.status && order.status.id != 'DELIVERED'" @click="handleOrderActionPopup(order, 'CANCELED')">ANULEAZA</button>
          </div>
        </div>
      </div>
    </div>

    <!--  -->
    <!--  LIST OF ORDERS TO BE PROCESSED IN THE NEXT 15 MINUTES -->
    <!--  -->

    <div class="section-bottom" v-if="ordersNext.length" v-bind:class="{ 'height-100pr' : ordersNew.length == 0 }">
      <div class="parent">
        <div class="col-single header-row">COMENZI DE PREGATIT ({{ordersNext.length}})</div>
      </div>

      <div class="section-scroll section-scroll-bottom">
        <div class="parent-list" v-for="order in ordersNext" :key="order.id">
          <div class="col-left-list" @click="openOrderDetails(order)">
            <span class="on badge-order-status">🛒 {{order.status.type}} Order</span>
            <span class="on"><b>Tel: {{order.delivery_details_phone}}</b> <span class="badge-delivery-type">{{order.delivery.type}}</span> ⏰ <span class="text-red text-bold">{{order.pickup_datetime}}</span> </span>
            <span v-show="order.comment && order.comment.length" class="on text-red text-bold">⚡ Clientul are observatii!</span>
            <span class="on">Total: {{order.totals_grandtotal}} {{order.currency}} <span v-bind:class="{ 'text-red text-bold' : order.status && order.status.id != 'DELIVERED' }">{{order.payment_type}}</span> <span v-if="order.payment_type == 'CARD'">💳</span><span v-else="">💰</span>
              <span v-show="order.payment_type == 'CARD' && order.capture_transaction_status == 'OK'" class="text-green"> - ACHITATA</span>
              <span v-show="order.payment_type == 'CARD' && order.capture_transaction_status == 'NOT OK'" class="text-red text-bold"> - RESPINSA ⚠🔥</span>
              <span v-show="order.payment_type == 'CARD' && order.capture_transaction_status != 'OK' && order.capture_transaction_status != 'NOT OK'" class="text-red text-bold"> - IN CURS DE PLATA ⚡</span>
            </span>
          </div>
          <div class="col-right-list text-right">
            <button class="btn btn-success btn-filter" v-show="order.status && order.status.id == 'NEW'" @click="handleOrderActionPopup(order, 'PROCESSING')">ACCEPTA / PREGATESTE</button>
            <button class="btn btn-success btn-filter" v-show="order.delivery && order.delivery.id == 'DELIVERY' && order.status.id == 'PROCESSING'" @click="handleOrderActionPopup(order, 'PREPARED')">PREGATITA</button>
            <button class="btn btn-info btn-filter" v-show="order.status && order.status.id != 'NEW'" @click="handleOrderActionPopup(order, 'DELIVERED')">LIVREAZA</button>
            <button class="btn btn-danger btn-filter" v-show="order.status && order.status.id != 'DELIVERED'" @click="handleOrderActionPopup(order, 'CANCELED')">ANULEAZA</button>
          </div>
        </div>
      </div>
    </div>

    <!--  -->
    <!-- POPUP CONFIRM ORDER CHANGE ACTION -->
    <!--  -->

    <div id="popupConfirmActionOrder">
      <div style="float: right; margin: 10px 45px;">
          <button ref="javascript:void(0)" class="btn btn-default btn-filter btn-close" @click="closePopupConfirmActionOrder">&times;</button>
        </div>
      <div class="overlay-content">
        <p class="confirm-message">CONFIRMATI SCHIMBAREA STATUSULUI COMENZII IN: <span class="badge-delivery-type">{{actionOrderStatus}}</span> ?</p>
        <p class="confirm-message" v-show="actionOrderStatus == 'PROCESSING'">
          Ora de livrare aleasa de client este cea de mai jos<br>dar o puteti modifica iar clientul va fi notificat despre aceasta modificare:
        </p>
        <button class="btn btn-success">CONFIRMA</button>
        <button class="btn btn-warning" @click="closePopupConfirmActionOrder">RENUNTA</button>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'home',
  data() {
    return {
      message: 'welcome',
      ordersNew: [],
      ordersNext: [],
      focusOrder: {
        token: null
      },
      actionOrderToken: null,
      actionOrderStatus: null,
      actionOrderPickupDate: null,
    }
  },
  created() {
    if (!!this.$route.query.jwtoken == true) {
      this.setupStream()
    }
  },
  methods: {
    handleOrderActionPopup(order, newStatus) {
      document.getElementById("popupConfirmActionOrder").style.height = "50%"
      let self = this
      self.actionOrderStatus = newStatus
    },
    closePopupConfirmActionOrder() {
      document.getElementById("popupConfirmActionOrder").style.height = "0%"
      let self = this
      self.actionOrderStatus = null
    },
    openOrderDetails(order) {
      this.focusOrder = order
      document.getElementById("popupConfirmActionOrder").style.height = "0%"
      document.getElementById("popupFocusOrder").style.width = "100%"
    },
    closeOrderDetails() {
      this.focusOrder = { token: null }
      document.getElementById("popupFocusOrder").style.width = "0%"
      document.getElementById("popupConfirmActionOrder").style.height = "0%"
    },
    setupStream() {
      let es = new EventSource(process.env.VUE_APP_API_URL + 'orders?jwtoken=' + this.$route.query.jwtoken)
      es.addEventListener('message', event => {
        let data = JSON.parse(event.data)
        this.ordersNew = data.news
        this.ordersNext = data.incomings
      }, false);
      es.addEventListener('error', event => {
        if (event.readyState == EventSource.CLOSED) {
          console.log('Event was closed')
          console.log(EventSource)
        }
      }, false)
    },
    lineTotal(a,b) {
      return a * b
    },
    formatValueFloat(value) {
      return parseFloat(value).toFixed(2)
    }
  },
  computed: {
    hasNoOrders: function () {
      return ( this.ordersNew.length == 0 && this.ordersNext == 0 )
    }
  }
}
</script>

<style>

.parent {
  display: flex;
}

.col-left {
  width: 30%;
  text-align: left;
  font-weight: bold;
  font-size: 18px;
}

.col-right {
  width: 70%;
}

.parent-list {
  display: flex;
  padding: 20px 6px;
  border: 1px solid lightblue;
  border-radius: 5px;
  background-color: floralwhite;
  margin-top: 10px;
}

.col-left-list {
  width: 52%;
  text-align: left;
  /* font-weight: bold; */
  font-size: 16px;
  cursor: pointer;
}

.col-right-list {
  width: 60%;
}

.col-single {
  text-align: left;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: .375rem .75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: .25rem;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  margin: 0px 6px;
}

.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}

.btn-info {
  color: #fff;
  background-color: #117a8b;
  border-color: #10707f;
}

.btn-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.btn-success {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}

.btn-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-warning {
  color: #000;
  background-color: darkorange;
  border-color: darkorange;
}

.text-right {
  text-align: right!important;
}

span.on {
	float: left;
	clear: both;
  margin-left: 10px;
  margin-bottom: 10px;
}

.order-brief {
	line-height: 30px;
	font-size: 20px;
}

.section-container {
	display: block;
	position: fixed;
	width: auto; 
	height: auto;
	top: 0; left: 0; right:0; bottom:0;
	background-color:rgb(255, 255, 255);
	height:100%;
	padding: 5px;
}

.section-top {
	position: relative;
	height: 50%;
	min-height: 50%;
  margin-bottom: 10px;
}

.section-bottom {
	position: relative;
	height: 50%;
}

.section-scroll {
	overflow-y: auto;
	position: relative;
  height: 85%;
}

.height-92pr {
  height: 92%;
}

.height-100pr {
  height: 100%;
}

@media(max-width: 500px) {
  /* .btn {
    cursor: pointer!important;
    float: right!important;
    clear: both!important;
    margin-bottom: 10px!important;
    font-size: 13px;
    font-weight: bold;
  } */

  .header-row {
    font-size: 18px;
    padding: 10px 0px;
    /* margin-top: 50px; */
  }

  .col-right-list {
    padding-top: 20px;
  }

  .section-scroll-top {
    height: 90%!important;
  }

  .section-scroll-bottom {
    height: 80%!important;
  }

  .btn-filter {
    padding: 4px;
    letter-spacing: 1px;  
    margin-bottom: 10px;
  }

  .card {
    font-size: 14px;
  }

  .btn {
    font-size: 14px!important;
  }

  .btn-close {
    font-size: 20px!important;
    font-weight: bold;
    padding: 0px 20px!important;
  }

}

@media(max-width: 955px) {
  .parent-list {
    flex-direction: column;
  }

  .col-left-list,
  .col-right-list {
    width: auto;
    text-align: left!important;
  }
}

@media(min-width: 800px) {
  .btn-filter {
    padding: 10px;
    letter-spacing: 2px;
    font-weight: bold;
  }

  .header-row {
    font-size: 30px;
    line-height: 80px;
  }

  .w-47-48pr {
    width: 48%!important;
  }
  
}

.header-row {
  font-weight: bold;
  width: 100%;
}

.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #f2f2f2;
  overflow-x: hidden;
  transition: 0.5s;
}

.overlay-content {
  /* position: relative; */
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 100px;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover, .overlay a:focus {
  color: #000;
}

.badge-delivery-type {
  border: 2px solid mediumseagreen;
  color: black!important;
  padding: 4px 10px;
  color: white;
  border-radius: 4px;
}

.badge-pickup-datetime {
  border: 2px solid #dc3545;
  color: black!important;
  padding: 4px 10px;
  color: white;
  border-radius: 4px;
}

.badge-order-status {
  border: 2px solid #d89cf6;
  padding: 4px 10px;
  color: black!important;
  border-radius: 4px;
}

.orders-table {
  width: 100%;
  margin: 0 auto;
}

.product-options,
.product-user-details {
  font-size: 13px;
}

.text-additional-info {
  color: red;
}

table {
  border-collapse: collapse;
}

table.orders-table tbody tr:not(:last-child),
table.orders-table thead tr {
  border-bottom: 1px solid lightgray;
}

table.orders-table tr td,
table.orders-table tr th {
  padding: 10px 5px;
}

table.orders-table > tbody > tr:last-child {
  border-bottom: none;
}

.card {
  border-radius: 6px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
  background-color: #FFFFFF;
  color: #252422;
  margin-bottom: 20px;
  /* position: relative; */
  padding: 4px;
}

.w-90pr {
  width: 90%;
  margin: 0 auto;
}

.w-47-48pr {
  width: 47%;
  margin: 0 auto;
}

.m-t-20px {
  margin-top: 20px;
}

.list-totals {
  list-style-type: none;
  padding-left: 0;
  text-align: left;
}

.list-totals li {
  margin-bottom: 10px;
}

.total-type {
  text-transform: uppercase;
  font-weight: bold;
}

.total-grand {
  font-weight: bold;
}

.splash {
  position: relative;
  width: 100%;
  height: 100vh;
}

.splash-content {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%,-50%);
  width: 200px;
  height: 200px;
}

.absolute {
  position: absolute;
  right: 60px;
  top: 20px;
}

.btn-close {
  background-color: lightgray;
  border-color: #dc3545;
  padding: 0px 30px;
  font-size: 26px;
  color: #dc3545;
}

#popupConfirmActionOrder {
  height: 0;
  min-width: 99%;
  z-index: 3;
  background-color: floralwhite;
  overflow-x: hidden;
  transition: 0.5s;
  margin: 0 auto;
  bottom: 0;
  position: fixed;
  border: 1px solid lightblue;
  border-radius: 5px;
}

.text-red {
  color: #dc3545;
}

.text-green {
  color: #28a745;
}

.text-bold {
  font-weight: bold;
}

.float-right {
  float: right;
}

.float-left {
  float: left;
}

.min-height-190 {
  min-height: 190px;
}

.phone-link {
  font-size: 16px!important;
  padding: 0px!important;
  color: red!important;
  min-width: 170px;
  margin: 0 auto;
}

.phone-link:hover {
  text-decoration: underline!important;
}

.confirm-message {
  font-weight: bold;
  font-size: 22px;
}


</style>
